/**
 * @fileoverview Shared checkbox atom.
 * @description A native checkbox input styled as a square box with a checkmark overlay, so it
 * keeps normal keyboard/click/focus behavior while matching the design's custom appearance.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

type CheckboxProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>

/**
 * @component
 * @param {CheckboxProps} props - Standard checkbox input attributes (id, checked, onChange, ...).
 */
function Checkbox(props: CheckboxProps) {
  return (
    <span className="relative inline-flex h-[22px] w-[22px] shrink-0 items-center justify-center">
      <input
        type="checkbox"
        className="peer absolute inset-0 h-full w-full cursor-pointer appearance-none rounded-md border-2 border-checkbox-border bg-white checked:border-primary checked:bg-primary"
        {...props}
      />
      <svg
        className="pointer-events-none absolute h-3 w-3 text-white opacity-0 peer-checked:opacity-100"
        viewBox="0 0 12 12"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M2 6L4.5 8.5L10 3"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  )
}

export default Checkbox
